export default __webpack_public_path__ + "assets/img/ic-pages-right.ef9708eca86ff8fa7b2698ff782289ec.svg";